import type { Plan } from '../types/subscription';

export const plans: Plan[] = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    period: 'month',
    description: 'Perfect for getting started',
    features: [
      {
        name: 'Content Ideas',
        description: '5 content ideas per month',
        included: true,
        limit: 5
      },
      {
        name: 'Content Plans',
        description: '1 content plan per month',
        included: true,
        limit: 1
      },
      {
        name: 'Basic Calendar',
        description: 'Simple content calendar',
        included: true
      },
      {
        name: 'Analytics',
        description: 'Basic analytics dashboard',
        included: false
      }
    ],
    limits: {
      contentIdeas: 5,
      contentPlans: 1,
      platforms: 1
    },
    hasTrial: false,
    trialDays: 0
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 49.00,
    period: 'month',
    description: 'For growing creators',
    features: [
      {
        name: 'Content Ideas',
        description: '30 content ideas per month',
        included: true,
        limit: 30
      },
      {
        name: 'Content Plans',
        description: '2 content plans per month',
        included: true,
        limit: 2
      },
      {
        name: 'AI Recommendations',
        description: 'Smart content suggestions',
        included: true
      },
      {
        name: 'Basic Analytics',
        description: 'Performance tracking',
        included: true
      }
    ],
    limits: {
      contentIdeas: 30,
      contentPlans: 2,
      platforms: 3
    },
    hasTrial: true,
    trialDays: 7
  },
  {
    id: 'premium_yearly',
    name: 'Premium Yearly',
    price: 499.00,
    period: 'year',
    description: 'For growing creators',
    features: [
      {
        name: 'Content Ideas',
        description: '30 content ideas per month',
        included: true,
        limit: 30
      },
      {
        name: 'Content Plans',
        description: '2 content plans per month',
        included: true,
        limit: 2
      },
      {
        name: 'AI Recommendations',
        description: 'Smart content suggestions',
        included: true
      },
      {
        name: 'Basic Analytics',
        description: 'Performance tracking',
        included: true
      }
    ],
    limits: {
      contentIdeas: 30,
      contentPlans: 2,
      platforms: 3
    },
    hasTrial: true,
    trialDays: 7
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 99.00,
    period: 'month',
    description: 'For professional creators',
    features: [
      {
        name: 'Content Ideas',
        description: '100 content ideas per month',
        included: true,
        limit: 100
      },
      {
        name: 'Content Plans',
        description: '5 content plans per month',
        included: true,
        limit: 5
      },
      {
        name: 'Real-time AI',
        description: 'Live trend analysis and recommendations',
        included: true
      },
      {
        name: 'Advanced Analytics',
        description: 'Including competitor tracking',
        included: true
      }
    ],
    limits: {
      contentIdeas: 100,
      contentPlans: 5,
      platforms: 5
    },
    hasTrial: true,
    trialDays: 7
  },
  {
    id: 'pro_yearly',
    name: 'Pro Yearly',
    price: 999.00,
    period: 'year',
    description: 'For professional creators',
    features: [
      {
        name: 'Content Ideas',
        description: '100 content ideas per month',
        included: true,
        limit: 100
      },
      {
        name: 'Content Plans',
        description: '5 content plans per month',
        included: true,
        limit: 5
      },
      {
        name: 'Real-time AI',
        description: 'Live trend analysis and recommendations',
        included: true
      },
      {
        name: 'Advanced Analytics',
        description: 'Including competitor tracking',
        included: true
      }
    ],
    limits: {
      contentIdeas: 100,
      contentPlans: 5,
      platforms: 5
    },
    hasTrial: true,
    trialDays: 7
  }
];

export const getPlan = (planId: string): Plan | undefined => {
  return plans.find(plan => plan.id === planId);
};

export const getNextPlan = (currentPlanId: string): Plan | undefined => {
  const currentIndex = plans.findIndex(plan => plan.id === currentPlanId);
  return currentIndex < plans.length - 1 ? plans[currentIndex + 1] : undefined;
};